import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { FooterComponent } from './components/footer/footer.component';
import { SobreNosComponent } from './components/sobre-nos/sobre-nos.component';
import { ServicosComponent } from './components/servicos/servicos.component';
import { IglooHeroComponent } from './components/igloo-hero/igloo-hero.component';
import { ProductsGalleryComponent } from './components/products-gallery/products-gallery.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    FooterComponent,
    SobreNosComponent,
    ServicosComponent,
    IglooHeroComponent,
    ProductsGalleryComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
